// https://vuex.vuejs.org/en/mutations.html
import Store from '@/store'

function getExistingPollingEntityIndex (state, entity) {
  var existingElementIndex = -1
  state.pollingEntities.some((el, index) => {
    if (el.dispatch === entity.dispatch && el.param === entity.param) {
      existingElementIndex = index
      return true
    }
  })
  return existingElementIndex
}

export default {
  refreshCountries (state, countries) {
    state.countries = countries
  },
  refreshSupportInfo (state, supportInfo) {
    state.supportInfo = supportInfo
  },

  removePollingEntity (state, entity) {
    var existingElementIndex = getExistingPollingEntityIndex(state, entity)
    if (existingElementIndex < 0) {
      return // entity to remove no longer exists
    }
    state.pollingEntities.splice(existingElementIndex, 1)
  },
  addPollingEntity (state, entity) {
    entity.remainingPolls = 5
    state.pollingEntities.push(entity)
    return true
  },
  reducePollingEntity (state, entity) {
    var existingElementIndex = getExistingPollingEntityIndex(state, entity)
    if (existingElementIndex < 0) {
      return // entity to reduce no longer exists
    }
    if (state.pollingEntities[existingElementIndex].remainingPolls <= 1) {
      state.pollingEntities.splice(existingElementIndex, 1)
      Store.dispatch('SetSnackBarMessage', {
        message: entity.failedMessage,
        color: 'warning',
      })
    } else {
      state.pollingEntities[existingElementIndex].remainingPolls =
        state.pollingEntities[existingElementIndex].remainingPolls - 1
    }
  },

  addLoadingMessage (state, message) {
    state.loadingMessages.push(message)
  },
  removeLoadingMessage (state, id) {
    var existingElementIndex = state.loadingMessages.findIndex(
      i => i.id === id
    )
    if (existingElementIndex > -1) {
      state.loadingMessages.splice(existingElementIndex, 1)
    }
  },

  addActivity (state, activity) {
    // add activity to the activity log
    state.activityLog.push(activity)
  },
  addNotification (state, notification) {
    // if there is an activity with matching requestId, add notification as a subset of the activity and add it to the unread list
    if (notification.requestId) {
      var index = state.activityLog.findIndex(
        e => e.id === notification.requestId
      )
      if (index > -1) {
        state.activityLog[index].notification.push(notification)
        state.unreadNotifications.push(notification)
      }
    }
  },
  markNotificationsAsRead (state, notification) {
    // remove all notifications from the unread list
    state.notification.splice(0, state.notification.length)
  },
}
